export const STEP_STATE = {
    current: 'CURRENT',
    passed: 'PASSED',
    next: 'NEXT',
};
export const PAYMENT_STEPS_WRAPPER_TEST_ID = 'checkout_PaymentSteps_wrapper';
export const PAYMENT_STEPS_NAVIGATION_TEST_ID = 'checkout_PaymentSteps_navigation';
